import React, { useEffect, useState } from "react";
import Trash from "@/assets/icons/Trash.svg";
import { motion } from "motion/react";
import { useNavigate } from "react-router-dom";

type action =
  | "edit"
  | "option"
  | "install"
  | "delete"
  | "integrations"
  | "inbox";

const options: any = [{ icon: Trash, text: "Delete report", action: "delete" }];

const ReportOptions = ({
  setShowConfirmDelete,
  setShowOptions,
}: {
  setShowConfirmDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setShowOptions: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();
  const handleOptionClick = (action: action) => {
    switch (action) {
      case "delete":
        setShowConfirmDelete(true);
        break;
      // case "inbox":
      //   navigate(`/inbox?website=${website.id}`);
      //   break;
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute w-[200px] options_shadow z-[50] top-[calc(100%+1px)] right-0 bg-black rounded-[17.6px] p-[1px]"
      >
        <div className="border-[0.5px] flex flex-col gap-[2px] border-white/[0.35] rounded-[17px] p-[2.5px]">
          {options.map((option: any, i: number) => {
            return (
              <button
                key={i}
                className="px-[10px] hover:bg-white/[0.15] rounded-[14px] transition-all py-[7px] text-[14px] onest-md leading-[17.85px] flex gap-[6px] items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleOptionClick(option.action);
                  setShowOptions(false);
                }}
              >
                <img src={option.icon} />
                {option.text}
              </button>
            );
          })}
        </div>
      </motion.div>
    </>
  );
};

export default ReportOptions;
